import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { Input } from '../../../../common/html/input'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { removeAccents } from '../../../../helpers/common'
import { formatVal } from '../../../../helpers/value'
import { COMPONENTS } from '../../../../routers/constants'
import classes from '../index.module.scss'
import {
  changeSettingOther,
  selectOtherSetting,
  selectPortfolios,
} from '../store/slice'

export const SelectPopup = ({ closePopup }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const portfolios = useSelector(selectPortfolios)
  const profilePortfolios = useSelector(selectOtherSetting('portfolios')) || []

  const [keyword, setKeyword] = useState('')
  const [checkedPortfolios, setCheckedPortfolios] = useState(profilePortfolios)

  const portfolioList = useMemo(() => {
    return portfolios.filter((item) =>
      removeAccents(item.portfolioName.toLowerCase()).includes(
        removeAccents(keyword.trim().toLowerCase()),
      ),
    )
  }, [portfolios, keyword])

  const handleSearchChange = (e) => {
    setKeyword(e.target.value)
  }

  const onCheckboxChange = (isCheck, item) => {
    let newCheckedPortfolios = [...checkedPortfolios]
    if (isCheck) {
      newCheckedPortfolios.push({
        portfolioId: item.portfolioId,
        portfolioName: item.portfolioName,
      })
    } else {
      newCheckedPortfolios = newCheckedPortfolios.filter(
        (i) => i.portfolioId !== item.portfolioId,
      )
    }
    setCheckedPortfolios(newCheckedPortfolios)
  }

  const onSubmit = () => {
    dispatch(changeSettingOther({ portfolios: checkedPortfolios }))
    closePopup()
  }

  return (
    <>
      <PopupAction
        isShow
        title="alertSetting.SELECT_PORTFOLIO"
        btnCancel={{
          label: 'common.CANCEL',
          isI18n: true,
          event: closePopup,
        }}
        btnSubmit={{
          label: 'common.APPLY',
          isI18n: true,
          event: onSubmit,
        }}
        handleClose={closePopup}
      >
        <Input
          value={keyword}
          onChange={handleSearchChange}
          placeHolder="alertSetting.SEARCH_PORTFOLIOS_PLH"
        />

        {!!checkedPortfolios.length && (
          <Element className="mt1 fw600" style={{ color: '#3A414B' }}>
            {formatVal(checkedPortfolios.length, locale, false, 0)}{' '}
            <Translate value="alertSetting.SELECTED" />
          </Element>
        )}

        <Element
          className={classes.portfolioList}
          style={{ backgroundColor: '#FFFFFF' }}
        >
          <ScrollComponent>
            {portfolioList.map((item) => (
              <Element
                key={item.portfolioId}
                className={classes.portfolioItem}
                style={{ borderColor: '#D5D5D5' }}
              >
                <Checkbox
                  checked={
                    checkedPortfolios.findIndex(
                      (i) => i.portfolioId === item.portfolioId,
                    ) !== -1
                  }
                  onChange={(isCheck) => onCheckboxChange(isCheck, item)}
                />
                <Element
                  className="breakWordAll cursorPointer"
                  style={{ color: '#2C73E8' }}
                >
                  <Link
                    to={`${COMPONENTS.library.components.savedPortfolios.components.detailsPortfolio.route}?id=${item.portfolioId}`}
                    target="_blank"
                  >
                    <TextEllipsisStaticLine
                      text={item.portfolioName}
                      isI18n={false}
                      tooltipMaxWidthByContent
                      zIndexTooltip={14}
                      lineClamp={1}
                    />
                  </Link>
                </Element>
              </Element>
            ))}
          </ScrollComponent>
        </Element>
      </PopupAction>
    </>
  )
}
